import type { ReactNode } from 'react';
import { Flex, Spinner, type FlexProps } from '@/ui';

type Props = FlexProps & {
  isLoading?: boolean;
  children?: ReactNode;
};

export const AttachmentThumbnailContainer = ({
  isLoading,
  bg,
  children,
  ...props
}: Props) => {
  return (
    <Flex
      align="center"
      aspectRatio="1"
      bg={bg || 'gray.200'}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      borderColor="gray.400"
      borderRadius="lg"
      borderStyle="solid"
      borderWidth="1px"
      h="120px"
      justify="center"
      pos="relative"
      {...props}
    >
      {isLoading && <Spinner />}

      {children}
    </Flex>
  );
};
